// extracted by mini-css-extract-plugin
export default {"deleteModuleText":"modals_deleteModuleText__XKe0o","colPadding":"modals_colPadding__ufdJa","rowCenter":"modals_rowCenter__0H31A"};